import React from 'react';
import Separator, { SeparatorType } from '@doordash/component-separator';
import { GridSeparatorContainer } from './styles.js';

var GridSeparator = function GridSeparator(_ref) {
  var isSquished = _ref.isSquished,
      insetHorizontalSize = _ref.insetHorizontalSize,
      insetVerticalSize = _ref.insetVerticalSize,
      type = _ref.type,
      middleColumn = _ref.middleColumn,
      shouldInsetStartAtTitle = _ref.shouldInsetStartAtTitle;
  var gridColumnStart = type === SeparatorType.InsetBorder && shouldInsetStartAtTitle ? middleColumn : 1;
  return /*#__PURE__*/React.createElement(GridSeparatorContainer, {
    gridColumnStart: gridColumnStart,
    type: type,
    isSquished: isSquished,
    insetHorizontalSize: insetHorizontalSize,
    insetVerticalSize: insetVerticalSize
  }, /*#__PURE__*/React.createElement(Separator, {
    type: type === SeparatorType.InsetBorder ? SeparatorType.FullBorder : type
  }));
};

export { GridSeparator as default };
